/*global $zopim*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoaderDotts from '../../dashboardNew/components/loader/LoaderDotts';
import Anchor from '../../dashboardNew/objects/Anchor';


class LoginForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPasswordVisible: false,
            termsAccepted: false,
            isRequest: false
        };
    }

    componentWillReceiveProps(nextProps) {
        nextProps.error && this.setState({ isRequest : false })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const formData = {}, form = e.target, email = form.email.value.trim(), password = form.password.value;
        formData.email = email;
        formData.password = password;
        formData.termsAccepted = this.state.termsAccepted;
        this.props.captureFormData(formData);
        form.reset();
        this.setState({ isRequest: true });
    };

    togglePassword = () => {
        this.setState({
            isPasswordVisible: !this.state.isPasswordVisible
        });
    };

    acceptsTerms = () => {
        this.setState({ termsAccepted: !this.state.termsAccepted });
    };

    render() {

        const image = '/images/meeting.jpg';
        const { error } = this.props;
        const isUS = false;
        return (

            <div className="container-fluid login-page-wrapper">
                <div className="image" style={{backgroundImage: `url(${image})`}}></div>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-5 col-xl-4 login-info">
                            {
                                this.state.isRequest ? (
                                    <LoaderDotts />
                                ) : (
                                    <form className="login-form-wrapper" action="" onSubmit={this.handleSubmit}>
                                        <div className="col-12 form-group">
                                            <h4 className="heading-three">Log in to your account</h4>
                                        </div>
                                        <div className="col-12 form-group">
                                            <label className="form-label" htmlFor="email">Email Address</label>
                                            <input className="form-input" type="email" name="email" id="email" required/>
                                        </div>
                                        <div className="col-12 form-group password">
                                            <label className="form-label" htmlFor="password">Password</label>
                                            <input className="form-input" type={this.state.isPasswordVisible ? 'text' : 'password'} name="password" id="password" required/>
                                            <input className="form-show-password" type="checkbox" name="show-password" id="show-password" onChange={this.togglePassword} checked={this.state.isPasswordVisible} />
                                            <label className="label-show-password" htmlFor="show-password"></label>
                                        </div>
                                        {error ? (
                                            <div className="col-12 form-group">
                                                <span className="error-message center no-margin">Incorrect email or password.</span>
                                            </div>
                                        ) : null}                                        
                                        <div class="col-12 form-group checkbox">
                                            <input class="form-input" type="checkbox" name="terms" id="terms" required="" onChange={this.acceptsTerms} checked={this.state.termsAccepted} required />
                                            <label class="form-label" for="terms">I accept the terms &amp; conditions relevant to my country of residency</label>
                                            <small id="emailHelp" class="form-text text-muted" style={{marginTop: '10px'}}>
                                                <a href="https://intouchnetworks.com/en-us/terms-and-conditions" target="_blank">US resident T&Cs</a><br />
                                                <a href="https://intouchnetworks.com/en-gb/terms-and-conditions" target="_blank">All other residents T&Cs</a>
                                            </small>
                                        </div>
                                        <div className="col-12 form-footer">
                                            <button className="theme-button" type="submit" >Log in</button>
                                            <Anchor anchorClass="clickable" path='/password-reset' internal>Forgotten your password?</Anchor>
                                        </div>
                                    </form>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

LoginForm.propTypes = {
    captureFormData: PropTypes.func,
    error: PropTypes.bool
}

export default LoginForm;



// WEBPACK FOOTER //
// src/client/components/common/authentication/LoginForm.js